// Заключване на приложението: ПИН (4 цифри) + по избор биометрия.
// ПИН-ът е ключалка на ЕКРАНА за това устройство — не е паролата на
// акаунта и не пътува към сървъра. Пази се като хеш, за да не стои в
// чист вид в хранилището (токените и без това са пак там — ПИН-ът е
// UX защита срещу любопитни очи, не срещу извлечен телефон).

import AsyncStorage from '@react-native-async-storage/async-storage';

const PIN_KEY = 'appPinHash';
// Питаме за защита ВЕДНЪЖ на устройство — при първия вход
const ASKED_KEY = 'securitySetupDone';

// Малък детерминистичен хеш (cyrb53) — без нативни модули, за да не чупи
// OTA на стари билдове, както стана с компресията на снимките.
function hashPin(pin: string): string {
  const str = `livupp-pin:${pin}`;
  let h1 = 0xdeadbeef;
  let h2 = 0x41c6ce57;
  for (let i = 0; i < str.length; i++) {
    const ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  return `${(h2 >>> 0).toString(16)}${(h1 >>> 0).toString(16)}`;
}

export async function setPin(pin: string): Promise<void> {
  await AsyncStorage.setItem(PIN_KEY, hashPin(pin));
}

export async function checkPin(pin: string): Promise<boolean> {
  const stored = await AsyncStorage.getItem(PIN_KEY);
  return !!stored && stored === hashPin(pin);
}

export async function hasPin(): Promise<boolean> {
  return !!(await AsyncStorage.getItem(PIN_KEY));
}

export async function securityAsked(): Promise<boolean> {
  return (await AsyncStorage.getItem(ASKED_KEY)) === '1';
}

export async function markSecurityAsked(): Promise<void> {
  await AsyncStorage.setItem(ASKED_KEY, '1');
}
